import { createApi } from '@reduxjs/toolkit/query/react';
import { updateCountryList, updateProcessorCredentialList, updateProvinceList } from '../slices/staticSlice';
import { baseQuery } from './baseQuery';
import { runRtkQuery } from '../helperFn';

export const staticApi = createApi({
  reducerPath: 'staticApi',
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getProvinceList: builder.query({
      query: (payload) => ({
        url: '/authrequest',
        method: 'POST',
        body: payload,
      }),
      async onQueryStarted(payload, { dispatch, queryFulfilled }) {
        const result = await runRtkQuery(payload, dispatch, queryFulfilled, 'getProvinceList');
        dispatch(updateProvinceList(result.data));
        let countryList = [];
        result.data.result.forEach((element) => {
          countryList.push({
            countryName: element.country.name,
            countryCode: element.country.code,
          });
        });
        dispatch(updateCountryList(countryList));
      },
    }),
    getProcessorCredentialList: builder.query({
      query: (payload) => ({
        url: '/authrequest',
        method: 'POST',
        body: payload,
      }),
      async onQueryStarted(payload, { dispatch, queryFulfilled }) {
        const result = await runRtkQuery(payload, dispatch, queryFulfilled, 'getProductForm');
        if (!result.error) {
          dispatch(updateProcessorCredentialList(result.data));
        }
      },
    }),
  }),
});

export const {
  useGetProvinceListQuery,
  useGetProcessorCredentialListQuery,
  useLazyGetProvinceListQuery,
  useLazyGetProcessorCredentialListQuery,
} = staticApi;
